import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

type FileDetails = {
  name: string;
  type: string;
  size: string;
  dimensions?: { width: number; height: number };
};

interface FileDetailsViewerProps {
  fileDetails: FileDetails | null;
}

const FileDetailsViewer: React.FC<FileDetailsViewerProps> = ({ fileDetails }) => {
  if (!fileDetails) return null;

  return (
    <div className="flex flex-col justify-center items-center">
      <span className="font-bold my-2">{fileDetails.name}</span>
      <span>
        {fileDetails.type} - {fileDetails.size}
      </span>
      {fileDetails.dimensions && (
        <span>
          <FontAwesomeIcon icon={faCircleCheck} className="mr-2" style={{ color: "#91ec9e" }} />
          {fileDetails.dimensions.width}px Width x {fileDetails.dimensions.height}px Height
        </span>
      )}
    </div>
  );
};

export default FileDetailsViewer;